import type { FaireProductEntity } from "../../entity_types/product";

export const p_qz8cqq22xh: FaireProductEntity = {
  token: "p_qz8cqq22xh",
  type: "product",
  name: "Mahjong Collective Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/1f9a4a92b22e82bfd90c7d331f1717055954614c3a7b6e6d65e942b5ef03ad50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/770ed590ce831dece61d1ddf7f3d247ff33d76b117cd3d1abd2a40f9b3cc3daa.jpeg",
    "https://cdn.faire.com/fastly/339831eadfca68b6485eb57bb4bc87060d55a2931f1319aa2f8b75d62ff8b762.jpeg",
    "https://cdn.faire.com/fastly/9d38444ce69ca694dfe54fff7949c638c3127ef3e698a151c41eab3cc83e559f.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:42.825Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
